import { useState } from "react";

import { ExpandableSection } from "@bokio/designsystem/components/ExpandableSection";
import { useDeviceQuery } from "@bokio/elements/DeviceQuery/useDeviceQuery";
import { GeneralLangFactory } from "@bokio/lang";

import * as styles from "./testCompanyTopBar.scss";

export const TestCompanyTopBar = () => {
	const lang = GeneralLangFactory();
	const { isMobile } = useDeviceQuery();

	const [isExpanded, setExpanded] = useState(false);
	const toggleExpanded = () => setExpanded(!isExpanded);

	if (isMobile) {
		return (
			<ExpandableSection expanded={isExpanded} onChange={toggleExpanded}>
				<ExpandableSection.Header
					className={styles.textHeader}
					headerText={lang.TestCompanyTopBar_Header}
					color="dark"
				/>
				<ExpandableSection.Content>
					<div className={styles.testCompanyTopBar}>
						<div className={styles.textContent}>
							<span className={styles.description}>{lang.TestCompanyTopBar_Description}</span>
						</div>
					</div>
				</ExpandableSection.Content>
			</ExpandableSection>
		);
	}

	return (
		<div className={styles.testCompanyTopBar} data-testid="TestCompanyTopBar">
			<div className={styles.textContent}>
				<span className={styles.textHeader}>{lang.TestCompanyTopBar_Header}</span>
				<span className={styles.description}>{lang.TestCompanyTopBar_Description}</span>
			</div>
		</div>
	);
};
